// Third party
import React from 'react';

// Components
import { UnitInput } from '../../../components/inputs';
import { PrimaryButton } from '../../../components/buttons';

// Utils
import { InfoTooltip } from '../../../components/tooltips';
import { ErrorTooltip } from '../../../components/tooltips';
import { formatMessage, FormattedMessage } from '../../../../utils/i18n';

type Props = {
  defaultValues?: { value: number; fee?: number };
  onAddToGroup: (value: number, fee?: number) => void;
};

type State = {
  groupValueFee: { value: number; fee?: number };
  hasValueError: boolean;
};

class ComparisonGroupsMenuForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      groupValueFee: props.defaultValues || { value: 0 },
      hasValueError: false,
    };
  }

  handleChanges = (options: { value?: number; fee?: number }) => {
    const { groupValueFee, hasValueError } = this.state;

    this.setState({
      groupValueFee: { ...groupValueFee, ...options },
      hasValueError: options.hasOwnProperty('value') ? !options.value : hasValueError,
    });
  };

  handleSubmission = () => {
    const { value, fee } = this.state.groupValueFee;
    this.props.onAddToGroup(value, fee != null ? fee / 100 : undefined);
  };

  render() {
    const { hasValueError, groupValueFee } = this.state;

    return (
      <div className="comparison-groups-menu-form">
        <div className="comparison-groups-menu-form__header">
          <h5>{formatMessage('Comparison.Groups.ValueFee.Title')}</h5>
        </div>

        <div className="comparison-groups-menu-form__field">
          <label htmlFor="groups-menu-value">
            <FormattedMessage id="Comparison.Groups.ValueFee.ValueLabel" />*
          </label>

          {hasValueError && (
            <ErrorTooltip
              title={formatMessage('Comparison.Groups.Tooltips.ValueErrorTitle')}
              message={formatMessage('Comparison.Groups.Tooltips.ValueErrorMessage')}
            />
          )}

          <UnitInput
            id="groups-menu-value"
            name="groups-menu-value"
            value={groupValueFee.value || ''}
            type="number"
            min={0}
            onValueChange={(value: string) => this.handleChanges({ value: Number(value) })}
            unitSymbol="$"
            error={hasValueError}
            compact
          />
        </div>
        <div className="comparison-groups-menu-form__field">
          <label htmlFor="groups-menu-fee">
            <FormattedMessage id="Comparison.Groups.ValueFee.FeeLabel" />
            <InfoTooltip message={formatMessage('HoldingsEditor.DiscretionaryMERInfo')} />
          </label>

          <UnitInput
            id="groups-menu-fee"
            name="groups-menu-fee"
            value={groupValueFee.fee || ''}
            type="number"
            min={0}
            onValueChange={(value: string) => this.handleChanges({ fee: Number(value) })}
            unitSymbol={formatMessage('Comparison.Groups.ValueFee.FeeUnit')}
            compact
          />
        </div>

        <PrimaryButton onClick={this.handleSubmission} disabled={!groupValueFee.value} className="comparison-groups-menu-form__button" compact>
          <FormattedMessage id="Comparison.Groups.ValueFee.AddValueFee" />
        </PrimaryButton>
      </div>
    );
  }
}

export default ComparisonGroupsMenuForm;
